
//通用控制state
export const handleKeyValue = 'Handle_KeyValue';

//获取种、册、条目、指标个数
export const Get_Count = 'Get_Count';
//获取年鉴列表
export const GET_YearbookList = 'GET_YearbookList';
//获取统计公报
export const GET_StatNews = 'GET_StatNews';

export const DrawEChart0 = 'DrawEChart0';
export const DrawEChart1 = 'DrawEChart1';
export const DrawEChart2 = 'DrawEChart2';
export const DrawEChart3 = 'DrawEChart3';

